import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'match-detail-dialog',
  templateUrl: '../sharedTemplates/match-detail-dialog.html',
})
export class MatchDetailDialog implements OnDestroy {
  private allSubscriptions: Subscription[] = [];
  public matchId = 0;
  public isLive = false;

  constructor(public _UiHelper: UiHelper) {
    this.allSubscriptions.push(
      this._UiHelper.matchDetailDataListener.subscribe((x: any) => {
        this.matchId = x.matchId;
        this.isLive = x.isLive;
      })
    );
  }

  ngOnDestroy() {
    this.matchId = 0;
    this.isLive = false;
    for (const subscription of this.allSubscriptions) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
